import { BaseHandler } from "../../../infrastructure/base-handlers";
import { translate } from "../../../localization";
import { existItemInCollection } from "../../domain/exist-item-in-collection";
import { ensureAreValidBasicActivityHistoryItems } from "../../domain/validation/is-valid-basic-history-item";
import { handleAddUpFilter } from "../../filter/up-filters/handle-add-up-options-from-item";
import { addActivityHistoryItem } from "./action";
import { AddHistoryItemPayload } from "./request";

export class AddHistoryItemHandler extends BaseHandler {
  async handle(payload: AddHistoryItemPayload) {
    try {
      ensureAreValidBasicActivityHistoryItems([payload.item]);

      // Check if item already exists in the collection
      const state = this.store.getState();
      const itemExists = existItemInCollection(state.activityHistoryCollections?.collections, payload.entityId, payload.item.id);
      const existFilterGroup = state.activityHistoryFilters?.filters?.find((item) => item.id === payload.entityId);
      if (itemExists) {
        throw new Error(translate("error.itemAlreadyExists"));
      }

      if (!existFilterGroup) {
        throw new Error(translate("error.filterNotInitialized"));
      }

      handleAddUpFilter([payload.item], this.store);
      this.store.dispatch(
        addActivityHistoryItem({
          id: payload.entityId,
          item: payload.item,
          componentFactory: payload.componentFactory,
        }),
      );
    } catch (e) {
      this.api.notificationService.error(e.message);
    }
  }
}
